import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import AvatarPlaceholder from '../../assets/images/avatar-placeholder.jpg';
import PropTypes from "prop-types";
import {FiFacebook, FiInstagram, FiLinkedin} from "react-icons/fi"

const Teamm = ({column, teamStyle, data}) => {
    return(
        <div className="row row--15">
            {data.map((item, index) => (
                <div className={column} key={index}>
                    <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                        <div className={`rn-team ${teamStyle}`}>
                            <div className="inner">
                                <figure className='thumbnail2'>
                                    <img src={item.member.avatar ?? AvatarPlaceholder} alt="IEEE Member Avatar" />
                                </figure>
                                <figcaption className="content">
                                    <h2 className="title">{item.member.fullName}</h2>
                                    <h6 className="subtitle theme-gradient">{item.role.title}</h6>
                                    <ul className="social-icon social-default icon-naked">
                                        {item.member.facebook && (<li className="mt--20"><a target="_blank" href={item.member.facebook}><FiFacebook /></a></li>)}
                                        {item.member.instagram && (<li className="mt--20"><a target="_blank" href={item.member.instagram}><FiInstagram /></a></li>)}
                                        {item.member.linkedin && (<li className="mt--20"><a target="_blank" href={item.member.linkedin}><FiLinkedin /></a></li>)}
                                    </ul>
                                </figcaption>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
Teamm.propTypes = {
    column: PropTypes.string,
    teamStyle: PropTypes.string,
    data: PropTypes.array.isRequired,
};
Teamm.defaultProps = {
    column: '',
    teamStyle: '',
};
export default Teamm;